export default __webpack_public_path__ + "static/media/hero-main.7130a83c.svg";